module.exports = __webpack_public_path__ + "img/matcap-top.3ffbc34f.png";